import React from "react";
import { useMachine } from "@xstate/react";
import { useRouter } from "next/router";

import { useAuth } from "@/hooks/useAuth";
import { IState } from "./types";
import { pricingMachine } from "./machine";
import { IPaymentType } from "../../Converter/types";

const Context = React.createContext<IState | null>(null);

export const PricingProvider: React.FC = React.memo(({ ...rest }) => {
  const router = useRouter();
  const { type } = router.query;
  const paymentType = type as IPaymentType;
  const { user } = useAuth();

  const [current, send] = useMachine(pricingMachine, {
    context: {
      paymentType,
      modalIsOpened: false,
      userEmail: user?.email ?? "",
      figmaPlanId: null,
      planQuantity: 50,
      isFigmaBackup: false,
    },
  });

  return <Context.Provider value={{ current, send }} {...rest} />;
});

export const usePricingContext = () => {
  const context = React.useContext(Context);

  if (!context) {
    throw Error("usePricingContext: Please provide provider value.");
  }

  return context;
};
